"use client";

import React from "react";

import { cn } from "utils";

export interface ChatCardEyebrowProps {
  /** 顶部弱标签，如 Ed's Picks for You */
  text: string;
  className?: string;
}

export const ChatCardEyebrow: React.FC<ChatCardEyebrowProps> = ({
  text,
  className,
}) => (
  <p className={cn("body_medium_s text-content_tertiary", className)}>{text}</p>
);
